import React from "react";
import WarrantyContainer from "../../container/admin/warranty";

const WarrantyView = () => {
    return <WarrantyContainer />;
};

export default WarrantyView;
